var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        footer: null,
        closable: false,
        width: "420px",
        centered: "",
      },
    },
    [
      _c(
        "div",
        { staticClass: "done-body", on: { keydown: _vm.handleKey } },
        [
          _c("a-icon", {
            staticClass: "done-icon",
            attrs: { type: "check-circle" },
          }),
          _c("div", { staticClass: "done-title" }, [_vm._v("结算成功")]),
          _c("div", { staticClass: "done-amount" }, [
            _vm._v("¥" + _vm._s(_vm.format(_vm.result.total))),
          ]),
          _c("div", { staticClass: "done-info" }, [
            _c("div", [_vm._v("单号：" + _vm._s(_vm.result.billNo))]),
            _c("div", [_vm._v("支付：" + _vm._s(_vm.result.payType))]),
            _vm.result.change > 0
              ? _c("div", [
                  _vm._v("找零：¥" + _vm._s(_vm.format(_vm.result.change))),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "done-actions" },
            [
              _c("a-button", { on: { click: _vm.printReceipt } }, [
                _vm._v("打印小票"),
              ]),
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.nextOrder } },
                [_vm._v("下一单（回车）")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.receipt
        ? _c(
            "div",
            {
              staticClass: "receipt-print",
              attrs: { id: "pos-receipt-print" },
            },
            [
              _c("div", { staticClass: "r-center r-bold" }, [
                _vm._v(_vm._s(_vm.receipt.shopName || "零售小票")),
              ]),
              _c("div", { staticClass: "r-center" }, [
                _vm._v("单号：" + _vm._s(_vm.receipt.number)),
              ]),
              _c("div", { staticClass: "r-center" }, [
                _vm._v("时间：" + _vm._s(_vm.receipt.operTime)),
              ]),
              _vm.receipt.memberName
                ? _c("div", { staticClass: "r-center" }, [
                    _vm._v(
                      "会员：" +
                        _vm._s(_vm.receipt.memberName) +
                        "（" +
                        _vm._s(_vm.receipt.levelName || "会员") +
                        "）"
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "r-line" }, [
                _vm._v("--------------------------------"),
              ]),
              _vm._l(_vm.receipt.items, function (item, i) {
                return _c("div", { key: i, staticClass: "r-item" }, [
                  _c("div", [
                    _vm._v(
                      _vm._s(item.material_unit) +
                        " × " +
                        _vm._s(item.oper_number) +
                        " × " +
                        _vm._s(item.unit_price)
                    ),
                  ]),
                  _c("div", { staticClass: "r-right" }, [
                    _vm._v("¥" + _vm._s(item.all_price)),
                  ]),
                ])
              }),
              _c("div", { staticClass: "r-line" }, [
                _vm._v("--------------------------------"),
              ]),
              _c("div", { staticClass: "r-item r-bold" }, [
                _c("span", [
                  _vm._v("合计：¥" + _vm._s(_vm.receipt.total_price)),
                ]),
              ]),
              _c("div", { staticClass: "r-item" }, [
                _c("span", [_vm._v("支付：" + _vm._s(_vm.receipt.pay_type))]),
              ]),
              _c("div", { staticClass: "r-center r-tip" }, [
                _vm._v("谢谢惠顾，欢迎再次光临"),
              ]),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }